/**
 * The wire contract of single-flight mutations, shared by the server that answers them and the clients that
 * ask: docs/notes/server/single-flight.md
 */

/** Request: the JSON list of `[path, input]` the client wants back. Response: `1` when the body is an envelope. */
export const SINGLE_FLIGHT_HEADER = 'x-trpc-flight'

/**
 * Past this many procedure calls (an infinite query counts one per page) the request is answered as a plain
 * mutation: one write must not fan out without bound.
 */
export const MAX_FLIGHT_QUERIES = 40

/**
 * A plain query is `[path, input?]`. An infinite one adds how many pages the client holds and its first cursor, and
 * comes back as `{ pages, pageParams }`, each next cursor read off the fresh page before it (`page.nextCursor`), as
 * the client's own refetch would walk them. The cursor is boxed because JSON turns an absent one into `null`.
 */
export type FlightRequest =
  | [path: string, input?: unknown]
  | [path: string, input: unknown, pages: number, firstCursor: { c?: unknown }]

/** One slot per requested query, in request order: `{ d }` is its result, `null` a read the client must refetch. */
export type FlightResult = { d: unknown } | null

export interface FlightEnvelope {
  flight: FlightResult[]
  /** The tRPC batch response, byte for byte what the endpoint answers without a flight. */
  batch: unknown
}
